import React from 'react';
import {
  Container,
  Grid,
  makeStyles
} from '@material-ui/core';
import Page from '../../../components/Page';
import NewsForm from './NewsForm';

import parseUrl from '../../../utils/parseUrl';

const useStyles = makeStyles((theme) => ({
  root: {
    backgroundColor: theme.palette.background.dark,
    minHeight: '100%',
    paddingBottom: theme.spacing(3),
    paddingTop: theme.spacing(3)
  }
}));

const NewsFormPage = () => {
  const classes = useStyles();

  const newsId = parseUrl(3);

  return (
    <Page
      className={classes.root}
      title="Новость"
    >
      <Container maxWidth="lg">
        <Grid
          container
          spacing={3}
        >
          <NewsForm newsId={newsId} />
        </Grid>
      </Container>
    </Page>
  );
};

export default NewsFormPage;
